import React, { useState } from 'react';

function MobileDoctorPersonalInfo({ user, onBack }) {
  const [form, setForm] = useState({
    name: user?.name || '',
    email: user?.email || '',
    phone: user?.phone || '',
    dob: user?.dateOfBirth || '',
  });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  const handleSave = async () => {
    setLoading(true);
    setTimeout(() => {
      setMessage('✅ Information updated successfully!');
      setLoading(false);
    }, 1000);
  };

  // Prevent double "Dr." prefix if user.name already contains it
  const displayName = user?.name?.startsWith('Dr.') ? user?.name : `Dr. ${user?.name || ''}`;

  return (
    // REMOVED 'pt-16' HERE TO ELIMINATE THE HUGE WHITE GAP
    <div className="pb-6 bg-[#f9f9fc] min-h-full" style={{ fontFamily: 'Inter, sans-serif' }}>
      
      {/* SUB-SCREEN HEADER */}
      <div className="flex items-center gap-3 px-4 py-3 bg-white border-b border-gray-100 sticky top-0 z-10">
        <button onClick={onBack} className="w-9 h-9 flex items-center justify-center rounded-full hover:bg-gray-100 active:scale-95 transition-all">
          <span className="material-symbols-outlined text-gray-500">arrow_back</span>
        </button>
        <span className="font-black text-[#0d1b2a] text-base">Personal Information</span>
      </div>

      <div className="px-4 pt-4 pb-4 space-y-4">
        {/* Avatar */}
        <div className="flex flex-col items-center py-2">
          <div className="w-20 h-20 rounded-full bg-[#0B3C95] flex items-center justify-center text-white font-black text-3xl mb-2 shadow-sm">
            {user?.name?.replace(/^dr\.?\s+/i, '').charAt(0).toUpperCase() || 'D'}
          </div>
          <p className="text-sm text-[#0B3C95] font-bold">{displayName}</p>
        </div>

        {message && (
          <div className="p-3 bg-green-50 border border-green-200 rounded-xl text-green-700 text-sm text-center font-semibold">
            {message}
          </div>
        )}

        <div className="bg-white rounded-2xl border border-gray-100 p-4 space-y-4" style={{ boxShadow: '0px 4px 20px rgba(0,0,0,0.05)' }}>
          {[
            { label: 'Full Name', key: 'name', icon: 'person', type: 'text', placeholder: 'Dr. Full Name' },
            { label: 'Email Address', key: 'email', icon: 'mail', type: 'email', placeholder: 'doctor@example.com' },
            { label: 'Phone Number', key: 'phone', icon: 'call', type: 'tel', placeholder: '+91 98765 43210' },
            { label: 'Date of Birth', key: 'dob', icon: 'cake', type: 'date', placeholder: '' },
          ].map(field => (
            <div key={field.key}>
              <label className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-1 block">{field.label}</label>
              <div className="flex items-center gap-3 bg-gray-50 rounded-xl px-3 py-3 border border-gray-200 focus-within:border-[#0B3C95] focus-within:bg-white transition-all">
                <span className="material-symbols-outlined text-gray-400 text-lg">{field.icon}</span>
                <input type={field.type} value={form[field.key]} placeholder={field.placeholder}
                  onChange={e => setForm({ ...form, [field.key]: e.target.value })}
                  className="flex-1 bg-transparent border-none outline-none text-sm text-[#1a1c1e] placeholder-gray-400" />
              </div>
            </div>
          ))}
        </div>

        <button onClick={handleSave} disabled={loading}
          className="w-full py-4 bg-[#0B3C95] text-white font-bold rounded-2xl text-sm active:scale-95 disabled:opacity-50 transition-all"
          style={{ boxShadow: '0 8px 25px rgba(11,60,149,0.3)' }}>
          {loading ? '⏳ Saving...' : 'Save Changes'}
        </button>
      </div>
    </div>
  );
}

export default MobileDoctorPersonalInfo;